import React, { useState } from 'react';
// import '../styles/Platform.css';

export default function Platform() {
  const [activeTab, setActiveTab] = useState('features');

  return (
    <div className="platform">
      <section className="platform-hero">
        <h1>Block-Based Website Builder</h1>
        <p>Create stunning websites with our innovative drag-and-drop platform</p>
        <button className="try-demo-btn">Try Demo</button>
      </section>

      <div className="platform-tabs">
        <button 
          className={activeTab === 'features' ? 'active' : ''}
          onClick={() => setActiveTab('features')}
        >
          Features
        </button>
        <button 
          className={activeTab === 'how-it-works' ? 'active' : ''}
          onClick={() => setActiveTab('how-it-works')}
        >
          How It Works
        </button>
        <button 
          className={activeTab === 'pricing' ? 'active' : ''}
          onClick={() => setActiveTab('pricing')}
        >
          Pricing
        </button>
      </div>

      <div className="platform-content">
        {activeTab === 'features' && (
          <div className="features-grid">
            <div className="feature-card">
              <h3>Drag & Drop Interface</h3>
              <p>Build websites intuitively with our visual block editor</p>
            </div>
            {/* Add more feature cards */}
          </div>
        )}
        
        {activeTab === 'how-it-works' && (
          <div className="how-it-works">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Choose Your Blocks</h3>
              <p>Select from our library of pre-designed blocks</p>
            </div>
            {/* Add more steps */}
          </div>
        )}

        {activeTab === 'pricing' && (
          <div className="pricing-plans">
            <div className="plan-card">
              <h3>Starter</h3>
              <div className="price">$0</div>
              <ul>
                <li>Basic blocks</li>
                <li>1 website</li>
                <li>Community support</li>
              </ul>
              <button>Get Started</button>
            </div>
            {/* Add more pricing plans */}
          </div>
        )}
      </div>
    </div>
  );
}